
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, April 23, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedusergroup",
	init: init,
	listeners: listeners,

	refresh: refresh,
	_loaded: false,
	_who: null,
	_group: null,
});

function init() {
	this.push(null);
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"managedaccount:updated": handle_managedaccount_update
	};
}

function refresh(){
	if(!this._who) return;
	// This is the manage group for the user, not the org group
	const group = this._group;
	this.api.manage.group(this._who, group).then(handle_load_group.bind(this));
}

function handle_load_group(data) {
	this.push(data);
}

function handle_managedaccount_update(data){
	var who = data.data._id;
	const group = data.group;
	if(this._who === who) return;
	this._who = who;
	this._group = group;
	this.refresh();
}
